import React from 'react';
import { StyledRadiusInput } from './RadiusInput.styled';

function RadiusInput(props) {
  const { radius, setRadius, radiusError, setRadiusError, isDisabled } = props;
  return (
    <StyledRadiusInput
      label='Radius'
      id='outlined-margin-none'
      value={radius}
      helperText={radiusError}
      variant='outlined'
      type='number'
      inputProps={{ min: '100', max: '10000' }}
      margin='dense'
      error={radiusError ? true : false}
      onChange={(e) => {
        setRadius(e.target.value);
        if (e.target.value < 100 || e.target.value > 10000) {
          setRadiusError('Invalid value');
          return;
        }
        setRadiusError('');
      }}
      disabled={isDisabled}
    />
  );
}

export default RadiusInput;
